import { Page, openPage } from '#/views/libs/pages';
import { RiverInfo } from '#/models/rivers/RiverInfo';
import { createAreaSelectorPage } from '#/views/index/areas/AreaSelectorPage';
import { createCatvInfoPage } from '#/views/index/catv/CatvInfoPage';
import { createCityInfoPage } from '#/views/index/city/CityInfoPage';
import { createRootPageToolbar } from '#/views/components/RootPageToolbar';
import { createRiverInfoViewer } from '#/views/components/rivers/RiverInfoViewer';
import { createGikaiInfoPage } from '#/views/index/gikai/GikaiInfoPage';

export interface RiverInfoViewerPageOptions {}

export function createRiverInfoViewerPage(options: RiverInfoViewerPageOptions): Page {
  const showBlue = () => {
    openPage(createCityInfoPage({}));
  };

  const showRed = () => {
    openPage(createAreaSelectorPage({}));
  };

  const showGreen = () => {
    openPage(createGikaiInfoPage({}));
  };

  const showYellow = () => {
    openPage(createCatvInfoPage({}));
  };

  const $toolbar = createRootPageToolbar();

  $toolbar.find('.btn-primary').on('click', (e) => {
    showBlue();
  });
  $toolbar.find('.btn-danger').on('click', (e) => {
    showRed();
  });
  $toolbar.find('.btn-success').on('click', (e) => {
    showGreen();
  });
  $toolbar.find('.btn-warning').on('click', (e) => {
    showYellow();
  });

  const [$riverInfo, disposeRiverInfoViewer] = createRiverInfoViewer(RiverInfo.rivers, {});

  $('body').append($toolbar);
  $('body').append($riverInfo);

  return {
    show: () => {
      $toolbar.show();
      $riverInfo.show();
    },
    hide: () => {
      $toolbar.hide();
      $riverInfo.hide();
    },
    unmount: () => {
      disposeRiverInfoViewer();
    },
    onKeydown: (e) => {
      switch (e.which) {
        case VK_BLUE:
          showBlue();
          break;
        case VK_RED:
          showRed();
          break;
        case VK_GREEN:
          showGreen();
          break;
        case VK_YELLOW:
          showYellow();
          break;
        default:
          break;
      }
    },
  };
}
